import { usePathname, useSearchParams } from 'next/navigation';
import { useCallback } from 'react';

export interface IUserCreateQueryStringUrlParams {
  params?: Record<string, string>;
  pathname?: string;
  customSearchParams?: string;
  toRemoveParams?: string[];
  clearAllParams?: boolean;
}

export const useCreateQueryStringUrl = () => {
  const searchParams = useSearchParams();
  const currentPathname = usePathname();

  return useCallback(
    ({
      params = {},
      pathname,
      customSearchParams,
      toRemoveParams,
      clearAllParams = false,
    }: IUserCreateQueryStringUrlParams) => {
      const urlSearchParams = new URLSearchParams(customSearchParams || (searchParams as unknown as string));

      for (const [name, value] of Object.entries(params)) {
        urlSearchParams.set(name, value);
      }

      if (toRemoveParams) {
        for (const name of toRemoveParams) {
          urlSearchParams.delete(name);
        }
      }

      if (clearAllParams) {
        for (const name of urlSearchParams.keys()) {
          urlSearchParams.delete(name);
        }
      }

      return (pathname || currentPathname) + '?' + urlSearchParams.toString();
    },
    [currentPathname, searchParams],
  );
};
